import React from 'react';
import {Section,SectionHeader} from '../ui/Section';
import {Card} from '../ui/Card';
import SafeIcon from '../../common/SafeIcon';
import {FiUsers,FiMap,FiSun} from 'react-icons/fi';

export const Capacity=()=> {
const capacities=[
  {
    icon: FiUsers,
    title: "Lobby & Bar Area",
    subtitle: "Social Space",
    capacity: "120–150 Guests",
    detail: "Perfect for cocktail hour or intimate social gatherings with historic charm."
  },
  {
    icon: FiMap,
    title: "Theatre / Ballroom",
    subtitle: "Indoor Dining",
    capacity: "Up to 250 Guests",
    detail: "Historic architecture with a grand stage and exceptional acoustics for dining."
  },
  {
    icon: FiSun,
    title: "Outdoor Courtyard",
    subtitle: "Al Fresco Dining",
    capacity: "Confirm with Team",
    detail: "Stunning foothill views. Layout and capacity depend on specific event needs."
  }
];

return (
  <Section id="capacity" bg="bg-white">
    <SectionHeader 
      title="Capacity at Padua" 
      subtitle="Our team can help confirm the best layout based on your guest count, dining style, ceremony needs, and weather plan." 
      className="mb-12" 
    />
    <div className="grid lg:grid-cols-3 gap-8 items-start">
      <div className="lg:col-span-1 lg:sticky lg:top-24">
        <h3 className="font-serif text-3xl md:text-4xl text-deep-charcoal mb-6">A Starting Point</h3>
        <p className="text-deep-charcoal/70 font-light leading-relaxed mb-8 text-lg">
          Once you have an idea of your preferred date and guest count, we can prepare a personalized estimate that reflects your celebration style.
        </p>
        <div className="p-6 bg-aged-ivory rounded-2xl border border-warm-stone/30">
          <p className="text-xs text-deep-charcoal/60 italic leading-relaxed">
            * Capacity may vary depending on layout, ceremony setup, dining style, dance floor, rentals, and weather plan.
          </p>
        </div>
      </div>
      <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-3 gap-4">
        {capacities.map((item,idx)=> (
          <Card key={idx} className="p-8 border-none shadow-soft flex flex-col justify-between hover:bg-aged-ivory/20 group h-full">
            <div>
              <div className="w-12 h-12 bg-aged-ivory rounded-full flex items-center justify-center mb-6 group-hover:bg-white transition-colors duration-300">
                <SafeIcon icon={item.icon} className="text-estate-bronze w-6 h-6" />
              </div>
              <p className="text-[10px] uppercase tracking-widest text-estate-bronze font-bold mb-2">{item.subtitle}</p>
              <h4 className="font-serif text-xl text-deep-charcoal mb-2">{item.title}</h4>
              <p className="text-olive-grove font-bold text-lg mb-4">{item.capacity}</p>
            </div>
            <p className="text-sm text-deep-charcoal/60 font-light leading-relaxed">{item.detail}</p>
          </Card>
        ))}
      </div>
    </div>
  </Section>
);
};